const languages = {
    en: {
        //File Types/Formats
        CSV: ".csv",
        TXT: ".txt",
        XLSX: ".xlsx",
        DATE_TYPE: "yyyy-mm-dd",


        //GUI・画面
        BTN_SAVE: "Save",
        BTN_NEXT: "Next",
        BTN_LOGOUT_YES: "Yes, Logout",
        BTN_CANCEL: "Cancel",
        BTN_MED_RECORDS: "Medical Records",
        BTN_AI_CHAT: "AI Chat",
        BTN_CONSULTATION: "Consultation",
        BTN_BASIC_INFO: "Basic Information",
        BTN_START_AI_CHAT: "Start AI Chat",
        BTN_VIEW_MED_RECORD: "View Medical Records",
        BTN_NEW_REGISTRATION: "New Registration",
        BTN_APPLY: "Apply Filter",
        BTN_REGISTER: "Register",
        BTN_SELECT: "Select",
        BTN_FOR_PATIENT: "Patient",
        BTN_FOR_DOCTOR: "Physician",
        BTN_FOR_EXPERT: "Expert Physician",
        BTN_LOGIN: "Login",
        BTN_LOGOUT: "Logout",
        BTN_REGENERATE_QUESTION: "Regenerate Questions",
        BTN_REGENERATE: "Regenerate",
        BTN_SKIP: "Skip Question",
        BTN_SUBMIT: "Submit",
        BTN_NEXT_AI_CHAT: "Next to AI Chat",
        BTN_SUBMIT_ANS: "Submit Answers",
        BTN_SHOW: "Show",
        BTN_QUERY: "Query",
        BTN_YES: "Yes",
        BTN_NO: "No",
        BTN_RETRY: "Retry",
        BTN_CLOSE: "Close",
        BTN_FILE_SELECT: "Select File",
        BTN_EDIT: "Edit",
        BTN_MANUAL: "Manual Input",
        BTN_FILEREGISTRATION: "File Registration",
        BTN_NEXT_CCOMPLAINT: "Next Page",
        BTN_RETURNTOLOGIN: "Return to Patient Selection",

        //Messages
        MSG_TYPE: "Type your message",
        MSG_LOADING01: "Loading",
        MSG_LOADING02: "Loading...",
        MSG_LOADING03: "Loading user details...",
        MSG_SEND: "Send",
        MSG_QUESTION: "What do you do?",
        MSG_THANK_YOU01: "Thank you very much.",
        MSG_THANK_YOU02: "Please proceed to the examination room when your number is called.",
        CONFIRMATION_LOGOUT: "Are you sure you want to log out?",
        MSG_COMMENT: "Enter your comments",
        MSG_NO_ANSWER: "No answer available",



        //Titles		
        TITLE_AI_CHAT: "AI Chat",
        TITLE_MED_INTERVIEW01: "MS Medical Interview",
        TITLE_MED_INTERVIEW02: "Support Tool",
        TITLE_PATIENT_PAGE: "Patient Page",
        TITLE_AI_MS_TOOL: "AI MS Tool",
        TITLE_ATTENDING_PHYSICIAN: "Physician",
        TITLE_DOCTOR_PAGE: "Doctor Page",
        TITLE_EXPERT_PHYSICIAN: "Expert Physician",
        TITLE_EXPERT_PAGE: "Expert Page",
        TITLE_PATIENT: "Patient",
        TITLE_WELCOME: "Welcome",
        TITLE_PATIENT_INFO: "Patient Information Form",
        TITLE_RESULTS: "Filtered Results",
        TITLE_QA: "Questions and Answers",
        TITLE_ERROR: "Error",



        //Question・質問
        RESPONSE_MSG: "Response on",
        QUESTION_ITEM: "Question",
        SAMPLE_ANSWER: "Sample answer:",
        ANSWER_NA: "N/A",
        ANSWER_NONE: "",
        ANSWER_ITEM: "Answer",
        HAPPINESS_DEFAULT_Q: "Something that made you happy recently",
        HAPPINESS_DEFAULT_A: "I went to a live performance.",
        HAPPINESS_DEFAULT_SA: "For example, a child won a prize",
        TROUBLE_DEFAULT_Q: "What is particularly troubling you at the moment?",
        TROUBLE_DEFAULT_A: "Nothing in particular",
        TROUBLE_DEFAULT_SA: "Ex: Paralysis in the right hand, pain in the right foot",
        CONCERNS_DEFAULT_Q: "Concerns or questions you want to ask",
        CONCERNS_DEFAULT_A: "Isn’t there too much medication?",
        CONCERNS_DEFAULT_SA: "How long do I have to continue the current treatment, advice on how to make it less likely to develop symptoms, etc.",
        SYMPTOMS_DEFAULT_Q: "Symptoms of concern (if any)",
        SYMPTOMS_DEFAULT_SA: "Numbness and muscle weakness in the right and right feet",
        SDURATION_DEFAULT_Q: "Duration of the symptom",
        SDURATION_DEFAULT_SA: "About three weeks ago",
        SPATTERN_DEFAULT_Q: "Symptom patterns",
        SPATTERN_DEFAULT_SA: "Have intermittent symptoms on hot days",
        SSEVERITY_DEFAULT_Q: "Symptom severity",
        SSEVERITY_DEFAULT_SA: "I have to interrupt my work when I have symptoms.",
        CCOMPLAINT_INSTRUCTION_01: "今の症状や、医師に伝えたい事について、以下の項目にお答え下さい",
        CCOMPLAINT_INSTRUCTION_02: "※自動的に、前回の入力が表示されています。今の内容に変更してください。",
        AI_CHAT_INSTRUCTION_01: "Please answer the AI-generated questions about your condition on a 5-point scale. When you select your answer, the next question will be displayed, for a total of 11 questions.      ",
        AI_CHAT_INSTRUCTION_02: "*If you don't understand a question, press [Regenerate] to regenerate the question. If there is a question you do not want to answer, press [I don't want to answer] to move on to the next question.     ",
        MAIN_ACTIVITIES_Q: "日中の主な活動（仕事内容など）",
        MAIN_ACTIVITIES_A: "エンジニア",
        MAIN_ACTIVITIES_SA: "エンジニア、事務職、販売員、家事",
        LIVING_WITH_Q: "同居している人（ペットを含め）",
        LIVING_WITH_A: "夫",
        LIVING_WITH_SA: "夫、娘（5歳と8歳）、猫、単身、一人暮らし、など",
        DIET_Q: "食生活",
        DIET_A: "食事を自分で作ります",
        DIET_SA: "バランスの取れた食事を心がけているが、忙しく外食もおおい",
        EXERCISE_Q: "運動",
        EXERCISE_SA: "定期的にヨガを行っているが、最近は暑さと症状のせいで休みがち",
        DAY_OFF_Q: "好きな休みの日の過ごし方",
        DAY_OFF_SA: "家族や友人と食事に行ったりする",
        DRIVING_Q: "自動車の運転（※こちらの質問は空白でお願いします）",
        DRIVING_SA: "ほぼ毎日、通勤や買い物で運転する",
        ALCOHOL_Q: "お酒",
        ALCOHOL_SA: "週に2日程度、ワインを１杯",
        SMOKING_Q: "喫煙量",
        SMOKING_SA: "週に１ダース、吸わない",
        HOPE_CHILD_Q: "挙児希望",
        HOPE_CHILD_SA: "30歳までに（※こちらの質問は空白でお願いします）",
        QUESTION_INSTRUCTION01: "最近変更がありましたら、以下の質問を回答してください：",
        QUESTION_INSTRUCTION02: "*前回の情報が表示されています。更新がなかったら、そのままにしてください。",


        //Selection:
        SELECTION_NOTLIKELY: "Not at all likely",
        SELECTION_SOMEWHAT: "Somewhat likely",
        SELECTION_NEUTRAL: "Neutral",
        SELECTION_LIKELY: "Likely",
        SELECTION_STRONGLY_AGREE: "Strongly Agree",
        SELECTION_1_NOTALLLIKELY: "1 - Not at all likely",
        SELECTION_2_NOTLIKELY: "2 - Not likely",
        SELECTION_3_SOMEWHAT: "3 - Somewhat likely",
        SELECTION_4_LESSNEUTRAL: "4 - Less than Neutral",
        SELECTION_5_NEUTRAL: "5 - Neutral",
        SELECTION_6_MORENEUTRAL: "6 - More Neutral",
        SELECTION_7_LIKELY: "7 - Likely",
        SELECTION_8_MORELIKELY: "8 - More Likely",
        SELECTION_9_AGREE: "9 - Agree",
        SELECTION_10_STRONGLY_AGREE: "10 - Strongly Agree",
        SELECTION_DONT_ANSWER: "I don’t want to answer",
        COGNITIVE_FCN_TEST_TYPE01: "SDMT（90秒での正当数）",
        COGNITIVE_FCN_TEST_TYPE02: "CogEVAL（調整済みZスコア）",
        MS_DIAGNOSIS_TYPE01: "MS",
        MS_DIAGNOSIS_TYPE02: "Clinical Isolated Syndrome",
        MS_DIAGNOSIS_TYPE03: "MS Suspicion",
        MS_DIAGNOSIS_TYPE04: "Others",
        ANTIBODY_TEST_AQP4_01: "Positive (CBA)",
        ANTIBODY_TEST_AQP4_02: "Positive (ELISA)",
        ANTIBODY_TEST_AQP4_03: "Negative (CBA)",
        ANTIBODY_TEST_AQP4_04: "Negative (ELISA)",
        ANTIBODY_TEST_MOG_01: "Positive (CBA)",
        ANTIBODY_TEST_MOG_02: "Positive (Others)",
        ANTIBODY_TEST_MOG_03: "Negative (CBA)",
        ANTIBODY_TEST_MOG_04: "Negative (Others)",
        OCB_RESULT01: "Positive",
        OCB_RESULT02: "Negative",
        CEREBROSPINAL_FLUID_TEST01: "LSI",
        CEREBROSPINAL_FLUID_TEST02: "SRL",
        CEREBROSPINAL_FLUID_TEST03: "Others",
        GENDER_SELECTION: "Select",
        GENDER_MALE: "Male",
        GENDER_FEMALE: "Female",
        GENDER_OTHERS: "Other",
        QOL: "QOL",
        COGNITIVE_FCN: "Cognitive Function",
        WALKING_FCN: "Walking Function",
        UPPER_LIMB_FCN: "Upper Limb Function",
        VISUAL_FCN: "Visual Function",
        MS_TYPE_01: "CIS",
        MS_TYPE_02: "RRMS",
        MS_TYPE_03: "SPMS",
        MS_TYPE_04: "PPMS",
        RECUR_NEVER: "Never",
        RECUR_ONCE: "Once",
        RECUR_TWO: "2-4 times",
        RECUR_OVER: "Over 5 times",
        OPTION_BLANK: "",


        //Labels・ラベル
        LBL_SELECT_EDOCTOR: "Select Expert Physician",
        LBL_ID: "ID",
        LBL_ID_INFO: "ID:",
        LBL_PASSWORD: "Password",
        LBL_FOR_PATIENT: "Patient",
        LBL_FOR_DOCTOR: "Physician",
        LBL_FOR_EXPERT: "Expert Physician",
        LBL_RESPONSE_DATE: "Date of Response",
        LBL_AVE_SCORE: "Average Score (1-5)",
        LBL_SELECT_CATEGORY: "Select Category",
        LBL_START_DATE: "Start Date",
        LBL_END_DATE: "End Date",
        LBL_LOGOUT_CONFIRMATION: "Confirm Logout",
        LBL_PATIENT_DETAILS: "Patient Details",
        LBL_PATIENT_NAME01: "Name:",
        LBL_PATIENT_NAME02: "Patient Name",
        LBL_research_id: "Patient ID",
        LBL_PATIENT_AGE: "Age:",
        LBL_PATIENT_EMAIL: "Email Address:",
        LBL_DATE_OF_BIRTH: "Date of Birth",
        LBL_GENDER: "Gender",
        LBL_MS_DIAGNOSIS: "MS Diagnosis",
        LBL_COMPLICATION: "Complications",
        LBL_MED_HISTORY: "Medical History",
        LBL_FAMILY_HISTORY: "Family History",
        LBL_FIRST_ONSET_DATE: "Date of first onset",
        LBL_FIRST_ONSET_LOCATION: "Location of first onset",
        LBL_FIRST_ONSET_SYMPTOM: "First onset symptom",
        LBL_MS_TYPE: "Type of MS",
        LBL_PIRA_PROGRESSION: "Presence or absence of PIRA",
        LBL_PIRA_TIME: "When PIRA was suspected",
        LBL_PIRA_SYMPTOMS: "Symptoms of PIRA",
        LBL_APQ4_TEST: "Antibody test (anti-AQP4)",
        LBL_MOG_TEST: "Antibody test (anti-MOG)",
        LBL_ANTIBODY_TEST: "Antibody test (other)",
        LBL_CEREBROSPINAL_TEST: "Whether or not cerebrospinal fluid testing is performed",
        LBL_FLUID_TEST_DATE: "When to perform cerebrospinal fluid testing",
        LBL_OCB_RESULT_TYPE: "OCB of cerebrospinal fluid test",
        LBL_FLUID_TEST_COMPANY: "Cerebrospinal fluid testing company",
        LBL_IGG_RESULT: "IgG index",
        LBL_SELECT_PATIENT: "Select a Patient",
        LBL_SELECT_PATIENT_DEFAULT: "--Select a Patient--",
        LBL_SELECTED_PATIENT01: "You have selected: ",
        LBL_SELECTED_PATIENT02: "Selected Patient:",
        LBL_PATIENT_SELECTION: "Choose a patient",
        LBL_PATIENT01: "Patient : ",
        LBL_PATIENT02: "Patient: ",
        LBL_AI_CHAT: "AI Chat",
        LBL_NO: "No",
        LBL_YES: "Yes",
        LBL_CONSULT_INFO: " の診察情報を入力してください。",
        LBL_SELECT_FILE: "Please select file to register",
        LBL_SELECTED_FILE: "Selected File:",
        LBL_CSV_DATA: "Extracted Patient Data:",
        LBL_DOCTOR: "Physician: ",
        LBL_CONDITION: "Condition: ",
        LBL_CCOMPLAINT: "Chief Complaint",
        LBL_QUESTION: "Question",
        LBL_ANSWER: " - Answer:",
        LBL_ANSWER02: "Answer:",
        LBL_PHYSICIAN_SELECTION: "Please select Physician",
        LBL_EPHYSICIAN_SELECTION: "Please select Expert Physician",
        LBL_SELECT_DOCTOR: "Select Physician",
        LBL_SELECT_DOCTOR_DEFAULT: "--Select Physician--",
        LBL_MANUAL_INPUT: "Manual Input",
        LBL_CSV_INPUT: "File Registration",
        LBL_PATIENT_LOADING: "Loading patients...",
        LBL_SELECT: "Select",
        LBL_PRESCRIPTION: "Prescription drug name",
        LBL_MRI_LESION: "New lesions on MRI",
        LBL_COUNT_RECURRENCE: "Number of recurrences excluding the first",
        LBL_DISABILITY_SUSPECT: "When disability progression was suspected in cases of SPMS",
        LBL_STATUS: "Status",
        LBL_DOCTOR_LOAD: "Loading doctors...",
        LBL_EXAM_RESULT: "Examination Results",
        LBL_FILE_REG_NOTES: "Only XLSX files are supported.",
        LBL_REGISTRATION: "Please select registration method",
        LBL_AGE: "years old",

        //Table Headers
        HEADER_DATE: "Date",
        HEADER_CATEGORY: "Category",
        HEADER_SCORE: "Score",
        HEADER_CONTENT: "Content",
        HEADER_EDSS: "EDSS Score",
        HEADER_TREATMENT: "治療：薬剤",
        HEADER_MRI_RESULT: "MRI検査結果における新規病変の有無",
        HEADER_RECURRENCE: "前回診察以降の再発の有無",
        HEADER_COGNITIVE_FCN_TEST: "認知検査：方法",
        HEADER_COGNITIVE_FCN_TIMING: "Timing of cognitive function testing",
        HEADER_COGNITIVE_FCN_RESULTS: "Cognitive function test results score",
        HEADER_PHYSICIAN_COMMENT: "Physicians Comment",
        HEADER_RECENT_RECURRENCE: "Recurrence since last visit",
        HEADER_SDMT_TEST_DATE: "Timing of cognitive function testing",
        HEADER_SDMT_TEST_TYPE: "Type of cognitive function test",
        HEADER_SDMT_TEST_SCORE: "Cognitive function test results score",
        HEADER_MED_RECORDS: "Medical Records",
        HEADER_MEDICINE: "Medicine",
        HEADER_MRI: "MRI Result",



        //Months・月
        JAN: "January",
        FEB: "February",
        MAR: "March",
        APR: "April",
        MAY: "May",
        JUN: "June",
        JUL: "July",
        AUG: "August",
        SEPT: "September",
        OCT: "Ocotober",
        NOV: "Novemeber",
        DEC: "December",


        //Medicines
        DRUG_OFATUMUMAB: "Ofatumumab",
        DRUG_SIPONIMOD: "Siponimod",
        DRUG_DMFU: "DMFu",
        DRUG_NATALIZUMAB: "Natalizumab",
        DRUG_FINGOLIMOD: "Fingolimod",
        DRUG_GLATIRAMER: "Glatiramer Acetate",
        DRUG_IFN_1A: "IFNβ-1a",
        DRUG_IFN_1B: "IFNβ-1b",
        NO_TREATMENT: "No treatment",

        //Categories
        CATEGORY_01: "FAMS_QOL_ACT",
        CATEGORY_02: "FAMS_QOL_SYM",
        CATEGORY_03: "FAMS_QOL_MEN",
        CATEGORY_04: "FAMS_QOL_SAT",
        CATEGORY_05: "FAMS_QOL_THOFAT",
        CATEGORY_06: "FAMS_QOL_SOCFAM",
        CATEGORY_06: "FAMS_QOL_OTH",
        CATEGORY_07: "MSNQ",
        CATEGORY_08: "AMSQ",
        CATEGORY_09: "MSWS",
        CATEGORY_10: "VQF",


        //Messages・メッセージ
        THANKYOU_MESSAGE: "Thank you for completing the questions!",
        LOGIN_MESSAGE01: "Login!",
        LOGIN_MESSAGE02: "You are logged in!",
        ERROR_LOADING: "Oops! Something went wrong.",
        LOADING_MESSAGE: "Loading User Information...",
        SELECTION_MESSAGE: "Please select a valid CSV file.",
        LOGIN_ERROR_MISSING: "Missing Username or Password",
        LOGIN_ERROR_INCORRECT: "*ID or password is incorrect",
        LOGIN_ERROR_UNAUTHORIZED: "Unauthorized",
        LOGIN_ERROR_NO_RESPONSE: "No Server Response",
        REGISTRATION_SUCCESSFUL: "User registered successfully",
        REGISTRATION_FAIL: "Failed to register user",
        LOADING_QUESTIONS: "Loading Questions...",
        REGISTRATION_METHOD: "登録方法を選択してください。",
        FETCH_ERROR: "Failed to fetch patients. Please try again later.",
        CONSULTATION_REG_OK: "Consultation registered successfully!",
        CONSULTATION_REG_NG: "Failed to register consultation.",
        SMOKE_NEVER: "Never",
        SMOKE_BEFORE: "Smoked in the past",
        SMOKE_CURRENT: "Currently smoking",
    },

    //日本語・Japanese
    jp: {
        //File Types/Formats
        CSV: ".csv",
        TXT: ".txt",
        XLSX: ".xlsx",
        DATE_TYPE: "yyyy-mm-dd",


        //GUI・画面
        BTN_SAVE: "保存",
        BTN_NEXT: "次へ",
        BTN_LOGOUT_YES: "はい、ログアウト",
        BTN_CANCEL: "キャンセル",
        BTN_MED_RECORDS: "診察ログ",
        BTN_AI_CHAT: "AIチャット",
        BTN_CONSULTATION: "診察",
        BTN_BASIC_INFO: "基本情報",
        BTN_START_AI_CHAT: "AI問診を開始",
        BTN_VIEW_MED_RECORD: "診療記録を見る",
        BTN_NEW_REGISTRATION: "新規登録",
        BTN_APPLY: "Apply Filter",
        BTN_REGISTER: "登録",
        BTN_SELECT: "決定",
        BTN_FOR_PATIENT: "患者",
        BTN_FOR_DOCTOR: "医師",
        BTN_FOR_EXPERT: "エキスパート医",
        BTN_LOGIN: "ログイン",
        BTN_LOGOUT: "ログアウト",
        BTN_REGENERATE_QUESTION: "質問を再生成",
        BTN_REGENERATE: "再生成",
        BTN_SKIP: "質問をスキップ",
        BTN_SUBMIT: "出す",
        BTN_NEXT_AI_CHAT: "次にAIチャット",
        BTN_SUBMIT: "回答を保存する",
        BTN_NEXT_AI_CHAT: "AIチャットへ",
        BTN_SUBMIT_ANS: "回答を提出",
        BTN_SHOW: "表示",
        BTN_QUERY: "問い合わせ",
        BTN_YES: "あり",
        BTN_NO: "なし",
        BTN_RETRY: "リトライ",
        BTN_CLOSE: "閉じる",
        BTN_FILE_SELECT: "ファイル選択",
        BTN_EDIT: "編集",
        BTN_MANUAL: "手動登録",
        BTN_FILEREGISTRATION: "ファイル登録",
        BTN_NEXT_CCOMPLAINT: "次のページへ",
        BTN_RETURNTOLOGIN: "患者選択に戻る",

        SMOKE_NEVER: "なし",
        SMOKE_BEFORE: "過去に喫煙していた",
        SMOKE_CURRENT: "現在も喫煙",

        //Messages
        MSG_TYPE: "メッセージを書いてください。",
        MSG_LOADING01: "ロード中",
        MSG_LOADING02: "ロード中...",
        MSG_LOADING03: "ユーザ情報はロード中。。。",
        MSG_SEND: "送信",
        MSG_QUESTION: "何をしますか？",
        MSG_THANK_YOU01: "お疲れ様でした。",
        MSG_THANK_YOU02: "番号が呼ばれたら、診察室までお越しください。",
        CONFIRMATION_LOGOUT: "ログアウトをしますか？",
        MSG_COMMENT: "コメントを入力してください",
        MSG_NO_ANSWER: "回答がありませんでした",



        //Titles		
        TITLE_AI_CHAT: "用のAIチャット",
        TITLE_MED_INTERVIEW01: "MS問診",
        TITLE_MED_INTERVIEW02: "支援ツール",
        TITLE_PATIENT_PAGE: "患者用ページ",
        TITLE_AI_MS_TOOL: "AIのMSツール",
        TITLE_LANDING_PAGE: "AIを使って、多発性硬化症面談に支援ツール",
        TITLE_AI_MS_TOOL: "MS診察支援AIツール",
        TITLE_ATTENDING_PHYSICIAN: "医師",
        TITLE_DOCTOR_PAGE: "医師画面",
        TITLE_EXPERT_PHYSICIAN: "エキスパート医",
        TITLE_EXPERT_PAGE: "エキスパート医画面",
        TITLE_PATIENT: "患者",
        TITLE_WELCOME: "ようこそ",
        TITLE_PATIENT_INFO: "患者情報",
        TITLE_RESULTS: "結果",
        TITLE_QA: "質問と回答",
        TITLE_ERROR: "エラー",




        //Question・質問
        RESPONSE_MSG: "回答日：",
        QUESTION_ITEM: "質問",
        SAMPLE_ANSWER: "回答例:",
        ANSWER_NA: "N/A",
        ANSWER_ITEM: "回答",
        HAPPINESS_DEFAULT_Q: "最近の嬉しかったこと",
        HAPPINESS_DEFAULT_A: "xxx 記入不要 xxx",
        HAPPINESS_DEFAULT_SA: "xxx 記入不要 xxx",
        TROUBLE_DEFAULT_Q: "いま特に困っていること",
        TROUBLE_DEFAULT_A: "xxx 記入不要 xxx",
        TROUBLE_DEFAULT_SA: "xxx 記入不要 xxx",
        CONCERNS_DEFAULT_Q: "不安や質問したいこと",
        CONCERNS_DEFAULT_A: "投薬がたくさんありませんか？",
        CONCERNS_DEFAULT_SA: "いつまでいまの治療を続けなくてはいけないか、症状が出にくくするためのアドバイス、など",
        SYMPTOMS_DEFAULT_Q: "現在の症状",
        SYMPTOMS_DEFAULT_SA: "xxx 記入不要 xxx",
        SDURATION_DEFAULT_Q: "現在の症状はいつからありますか？",
        SDURATION_DEFAULT_SA: "約３週間前から",
        SPATTERN_DEFAULT_Q: "その症状のパターン",
        SPATTERN_DEFAULT_SA: "xxx 記入不要 xxx",
        SSEVERITY_DEFAULT_Q: "その症状のひどさ",
        SSEVERITY_DEFAULT_SA: "xxx 記入不要 xxx",
        CCOMPLAINT_INSTRUCTION_01: "今の症状や、医師に伝えたい事について、以下の項目にお答え下さい",
        CCOMPLAINT_INSTRUCTION_02: "※自動的に、前回の入力が表示されています。今の内容に変更してください。",
        AI_CHAT_INSTRUCTION_01: "AIで生成した質問に10点スケールで回答してください。質問は全部で13問です。",
        AI_CHAT_INSTRUCTION_02: "",
        MAIN_ACTIVITIES_Q: "日中の主な活動（仕事内容など）",
        MAIN_ACTIVITIES_A: "エンジニア",
        MAIN_ACTIVITIES_SA: "エンジニア、事務職、販売員、家事",
        LIVING_WITH_Q: "同居している人（ペットを含め）",
        LIVING_WITH_A: "夫",
        LIVING_WITH_SA: "夫、娘（5歳と8歳）、猫、単身、一人暮らし、など",
        DIET_Q: "食生活",
        DIET_A: "食事を自分で作ります",
        DIET_SA: "バランスの取れた食事を心がけているが、忙しく外食もおおい",
        EXERCISE_Q: "運動",
        EXERCISE_SA: "定期的にヨガを行っているが、最近は暑さと症状のせいで休みがち",
        DAY_OFF_Q: "好きな休みの日の過ごし方",
        DAY_OFF_SA: "家族や友人と食事に行ったりする",
        DRIVING_Q: "自動車の運転",
        DRIVING_SA: "xxx 記入不要 xxx",
        ALCOHOL_Q: "お酒",
        ALCOHOL_SA: "週に2日程度、ワインを１杯",
        SMOKING_Q: "喫煙量",
        SMOKING_SA: "週に１ダース、吸わない",
        HOPE_CHILD_Q: "挙児希望",
        HOPE_CHILD_SA: "xxx 記入不要 xxx",
        QUESTION_INSTRUCTION01: "最近変更がありましたら、以下の質問を回答してください：",
        QUESTION_INSTRUCTION01: "最近変更がありましたら、以下の質問に回答をしてください",
        QUESTION_INSTRUCTION02: "*前回の情報が表示されています。更新がなかったら、そのままにしてください。",


        //Selection:
        SELECTION_NOTLIKELY: "全く思わない",
        SELECTION_SOMEWHAT: "あまりそう思わない",
        SELECTION_NEUTRAL: "当たり障りのない",
        SELECTION_NEUTRAL: "どちらでもない",
        SELECTION_LIKELY: "ややそう思う",
        SELECTION_STRONGLY_AGREE: "強く思う",
        SELECTION_1_NOTALLLIKELY: "1",
        SELECTION_2_NOTLIKELY: "2",
        SELECTION_3_SOMEWHAT: "3",
        SELECTION_4_LESSNEUTRAL: "4",
        SELECTION_5_NEUTRAL: "5",
        SELECTION_6_MORENEUTRAL: "6",
        SELECTION_7_LIKELY: "7",
        SELECTION_8_MORELIKELY: "8",
        SELECTION_9_AGREE: "9",
        SELECTION_10_STRONGLY_AGREE: "10",
        SELECTION_DONT_ANSWER: "回答したくない",
        COGNITIVE_FCN_TEST_TYPE01: "SDMT（90秒での正当数）",
        COGNITIVE_FCN_TEST_TYPE02: "CogEVAL（調整済みZスコア）",
        MS_DIAGNOSIS_TYPE01: "MS",
        MS_DIAGNOSIS_TYPE02: "Clinical Isolated Syndrome",
        MS_DIAGNOSIS_TYPE03: "MS疑い",
        MS_DIAGNOSIS_TYPE04: "その他",
        ANTIBODY_TEST_AQP4_01: "陽性（CBA）",
        ANTIBODY_TEST_AQP4_02: "陽性（ELISA）",
        ANTIBODY_TEST_AQP4_03: "陰性（CBA）",
        ANTIBODY_TEST_AQP4_04: "陰性（ELISA）",
        ANTIBODY_TEST_MOG_01: "陽性（CBA）",
        ANTIBODY_TEST_MOG_02: "陽性（その他）",
        ANTIBODY_TEST_MOG_03: "陰性（CBA）",
        ANTIBODY_TEST_MOG_04: "陰性（その他）",
        OCB_RESULT01: "陽性",
        OCB_RESULT02: "陰性",
        CEREBROSPINAL_FLUID_TEST01: "LSI",
        CEREBROSPINAL_FLUID_TEST02: "SRL",
        CEREBROSPINAL_FLUID_TEST03: "その他",
        GENDER_SELECTION: "選択",
        GENDER_MALE: "男性",
        GENDER_FEMALE: "女性",
        GENDER_OTHERS: "その他",
        QOL: "QOL",
        COGNITIVE_FCN: "認知機能",
        WALKING_FCN: "歩行機能",
        UPPER_LIMB_FCN: "上肢機能",
        VISUAL_FCN: "視機能",
        MS_TYPE_01: "CIS",
        MS_TYPE_02: "RRMS",
        MS_TYPE_03: "SPMS",
        MS_TYPE_04: "PPMS",
        RECUR_NEVER: "なし",
        RECUR_ONCE: "１回",
        RECUR_TWO: "2-4回",
        RECUR_OVER: "5回以上",


        //Labels・ラベル
        LBL_SELECT_EDOCTOR: "主治医選択",
        LBL_ID: "ID",
        LBL_ID_INFO: "ID:",
        LBL_PASSWORD: "パスワード",
        LBL_FOR_PATIENT: "患者",
        LBL_FOR_DOCTOR: "医師",
        LBL_FOR_EXPERT: "エキスパート医",
        LBL_RESPONSE_DATE: "回答日",
        LBL_AVE_SCORE: "平均のスコア(1-5)",
        LBL_SELECT_CATEGORY: "カテゴリーを選択",
        LBL_START_DATE: "開始日",
        LBL_END_DATE: "完了日",
        LBL_LOGOUT_CONFIRMATION: "ログアウト確認",
        LBL_PATIENT_DETAILS: "患者除法",
        LBL_PATIENT_NAME01: "名前：",
        LBL_PATIENT_NAME02: "患者名",
        LBL_research_id: "患者ID",
        LBL_PATIENT_AGE: "年齢:",
        LBL_PATIENT_EMAIL: "メールアドレス：",
        LBL_DATE_OF_BIRTH: "生年月日",
        LBL_GENDER: "性別",
        LBL_MS_DIAGNOSIS: "MS診断",
        LBL_COMPLICATION: "合併症",
        LBL_MED_HISTORY: "既往歴",
        LBL_FAMILY_HISTORY: "家族歴",
        LBL_FIRST_ONSET_DATE: "初回attack時期",
        LBL_FIRST_ONSET_LOCATION: "初回attack部位",
        LBL_FIRST_ONSET_SYMPTOM: "初回attack症状",
        LBL_MS_TYPE: "MSの種類",
        LBL_PIRA_PROGRESSION: "慢性進行の有無",
        LBL_PIRA_TIME: "慢性進行が疑われた時期",
        LBL_PIRA_SYMPTOMS: "障害進行の症状",
        LBL_APQ4_TEST: "抗AQP4抗体検査結果",
        LBL_MOG_TEST: "抗MOG抗体検査結果",
        LBL_ANTIBODY_TEST: "その他自己抗体が陽性のもの",
        LBL_CEREBROSPINAL_TEST: "髄液検査実施の有無",
        LBL_FLUID_TEST_DATE: "髄液検査実施の時期",
        LBL_OCB_RESULT_TYPE: "髄液検査結果（OCB）",
        LBL_FLUID_TEST_COMPANY: "髄液検査実施会社",
        LBL_IGG_RESULT: "髄液検査結果（IgG index）",
        LBL_SELECT_PATIENT: "患者選択",
        LBL_SELECT_PATIENT_DEFAULT: "--患者選択--",
        LBL_SELECTED_PATIENT01: "選択結果: ",
        LBL_SELECTED_PATIENT02: "選択した患者：",
        LBL_PATIENT_SELECTION: "患者を選択",
        LBL_PATIENT01: "患者 : ",
        LBL_PATIENT02: "患者: ",
        LBL_AI_CHAT: " AIチャット用",
        LBL_NO: "なし",
        LBL_YES: "あり",
        LBL_CONSULT_INFO: " の診察情報を入力してください。",
        LBL_SELECT_FILE: "登録するファイルを選択",
        LBL_SELECTED_FILE: "選択したファイル名：",
        LBL_CSV_DATA: "抽出された患者データ:",
        LBL_DOCTOR: "医師: ",
        LBL_CONDITION: "条件: ",
        LBL_CCOMPLAINT: "用の主訴",
        LBL_QUESTION: "質問",
        LBL_ANSWER: " - 回答：",
        LBL_ANSWER02: "回答：",
        LBL_PHYSICIAN_SELECTION: "医師を選択してください。",
        LBL_EPHYSICIAN_SELECTION: "エキスパート医師を選択してください。",
        LBL_SELECT_DOCTOR: "医師選択",
        LBL_SELECT_DOCTOR_DEFAULT: "--医師選択--",
        LBL_MANUAL_INPUT: "マニュアル入力",
        LBL_CSV_INPUT: "ファイル登録",
        LBL_PATIENT_LOADING: "患者をロード中。。。",
        LBL_SELECT: "選択",
        LBL_PRESCRIPTION: "処方薬",
        LBL_MRI_LESION: "MRIに病変",
        LBL_COUNT_RECURRENCE: "初回を含めたattackの回数",
        LBL_DISABILITY_SUSPECT: "障害進行が疑われた時期（SPMSの場合）",
        LBL_STATUS: "ステータス",
        LBL_DOCTOR_LOAD: "医師ロード中。。。",
        LBL_EXAM_RESULT: "診察結果",
        LBL_FILE_REG_NOTES: "XLSXファイルのみサポートされている。",
        LBL_REGISTRATION: "患者登録方法選択",
        LBL_AGE: "歳",

        //Table Headers
        HEADER_DATE: "日付",
        HEADER_CATEGORY: "カテゴリ",
        HEADER_SCORE: "スコア",
        HEADER_CONTENT: "内容",
        HEADER_EDSS: "EDSSスコア",
        HEADER_TREATMENT: "治療：薬剤",
        HEADER_MRI_RESULT: "MRI検査結果における新規病変の有無",
        HEADER_RECURRENCE: "前回診察以降の再発の有無",
        HEADER_COGNITIVE_FCN_TEST: "認知検査：方法",
        HEADER_COGNITIVE_FCN_TIMING: "認知検査：時期",
        HEADER_COGNITIVE_FCN_RESULTS: "認知検査：結果",
        HEADER_PHYSICIAN_COMMENT: "医師コメント",
        HEADER_RECENT_RECURRENCE: "前回診察以降の再発の有無",
        HEADER_SDMT_TEST_DATE: "認知機能検査実施時期",
        HEADER_SDMT_TEST_TYPE: "認知機能検査実施方法",
        HEADER_SDMT_TEST_SCORE: "認知機能検査結果",
        HEADER_MED_RECORDS: "診療記録",
        HEADER_MEDICINE: "薬剤",
        HEADER_MRI: "MRI結果",



        //Months・月
        JAN: "一月",
        FEB: "二月",
        MAR: "三月",
        APR: "四月",
        MAY: "五月",
        JUN: "六月",
        JUL: "七月",
        AUG: "八月",
        SEPT: "九月",
        OCT: "十月",
        NOV: "十一月",
        DEC: "十二月",


        //Medicines
        DRUG_OFATUMUMAB: "ケシンプタ（オファツムマブ）",
        DRUG_SIPONIMOD: "メーゼント（シポニモド）",
        DRUG_DMFU: "テクフィデラ（フマル酸ジメチル）",
        DRUG_NATALIZUMAB: "タイサブリ（ナタリズマブ）",
        DRUG_FINGOLIMOD: "イムセラ・ジレニア（フィンゴリモド）",
        DRUG_GLATIRAMER: "コバキソン（グラチラマー酢酸塩）",
        DRUG_IFN_1A: "アボネックス（IFNβ-1a）",
        DRUG_IFN_1B: "ベタフェロン（IFNβ-1b）",
        NO_TREATMENT: "無治療",


        //Categories
        CATEGORY_01: "FAMS_QOL_ACT",
        CATEGORY_02: "FAMS_QOL_SYM",
        CATEGORY_03: "FAMS_QOL_MEN",
        CATEGORY_04: "FAMS_QOL_SAT",
        CATEGORY_05: "FAMS_QOL_THOFAT",
        CATEGORY_06: "FAMS_QOL_SOCFAM",
        CATEGORY_06: "FAMS_QOL_OTH",
        CATEGORY_07: "MSNQ",
        CATEGORY_08: "AMSQ",
        CATEGORY_09: "MSWS",
        CATEGORY_10: "VQF",


        //Messages・メッセージ
        THANKYOU_MESSAGE: "回答していただいて、ありがとうございました！",
        LOGIN_MESSAGE01: "ログイン！",
        LOGIN_MESSAGE02: "ログインできました！",
        ERROR_LOADING: "Oops! Something went wrong.",
        LOADING_MESSAGE: "ユーザ情報をロードしています。。。",
        SELECTION_MESSAGE: "正しいファイルを選択してください。",
        LOGIN_ERROR_MISSING: "Missing Username or Password",
        LOGIN_ERROR_INCORRECT: "IDかパスワードが間違っています。",
        LOGIN_ERROR_UNAUTHORIZED: "Unauthorized",
        LOGIN_ERROR_NO_RESPONSE: "No Server Response",
        REGISTRATION_SUCCESSFUL: "ユーザーの登録が完了しました!",
        REGISTRATION_FAIL: "ユーザーの登録に失敗しました。",
        LOADING_QUESTIONS: "質問をロードしています。。。",
        REGISTRATION_METHOD: "登録方法を選択してください。",
        FETCH_ERROR: "Failed to fetch patients. Please try again later.",
        CONSULTATION_REG_OK: "診察正しく登録できました！",
        CONSULTATION_REG_NG: "診察の登録に失敗しました。",

    }
};

export default languages;
